import { Media } from 'surveys/common/types/R4ESurvey3Common';

export interface SurveyResponseRequest {
    id: string | null;
    text: string;

    medias?: Media[] | null;
    parentID?: string;
    surveyResponseChannel?: string;
    emailSender?: string;
}

export enum ResponseState {
    Start = 0,
    PendingManual = 1,
    PendingApproval = 2,
    PendingModeration = 3,
    Posted = 4,
    Rejected = 5,
    PendingPublish = 6,
    Published = 7,
    Failed = 8,
    Live = 9,
}

export enum SurveyResponseChannel {
    EMAIL = 'Email',
    SMS = 'SMS',
    ANONYMOUS = 'Anonymous',
}

export enum SurveyMediaType {
    Link = 'Link',
    Photo = 'Photo',
    Video = 'Video',
    NotMapped = 'Not_Mapped',
    Sticker = 'Sticker',
    Audio = 'Audio',
}

export enum EmailSender {
    LOCATION = 'LOCATION',
    USER = 'USER',
}

export interface SurveyResponse {
    responseStateDetails: Array<{
        responseState: ResponseState;
        userId: number;
        responseStateDate: string;
    }>;
    localDateTime: string;
    r4eAgencyId: number;
    r4eTenantId: number;
    activityUrl: string;
    r4eLocationUid: number;
    taxonomyOverallSentimentModelScore: number;
    confusionScore: number;
    language: string;
    countryCode: string;
    pastTenseScore: number;
    location: {
        lat: number;
        lon: number;
    };
    postMedia: string;
    region: string;
    regionCode: string;
    domain: string;
    postCreatedAt: string;
    angerScore: number;
    taxonomyNer: Array<{
        ner: string;
        sentiment: number;
    }>;
    taxonomyUseR4eTranslation: boolean;
    hasMedia: boolean;
    dataSourceType: string;
    taxonomyOverallImpactFromSentimentModelScore: number;
    anticipationScore: number;
    fingerprint: string;
    companyUid: string;
    socialSourceUid: string;
    r4eLabelIds: number[];
    authorPictureUrl: string;
    taxonomyHash: number;
    subjectivityScore: number;
    taxonomyCustomerJourneyStages: Array<{
        categories: Array<{
            categoryId: string;
            keywords: string[];
            sentenceIndex: number;
            sentenceText: string;
            sentiment: number;
            uuid: string;
        }>;
        stageId: string;
        stageName: string;
    }>;
    externalDataSource: string;
    responseTimeMs: number;
    isVerified: boolean;
    companyScore: number;
    version: string;
    positiveSentiment: number;
    secondsFromWeekStart: number;
    taxonomyCustomerJourneyIds: number[];
    sentimentScore: number;
    authorRealName: string;
    locationAttributes: Array<{
        reputationName: string;
        attributeName: string;
        attributeValue: string;
        companyAttributeId: string;
    }>;
    solicitationScore: number;
    taxonomyOverallImpact: number;
    mentionsExpanded: string;
    trustScore: number;
    presentTenseScore: number;
    isComment: boolean;
    rawBodyText: string;
    rawImageText: string;
    rawImageWords: string;
    repNormalizedRating: number;
    ratingValue: number;
    fearScore: number;
    disgustScore: number;
    authorRealNameText: string;
    surpriseScore: number;
    activityType: string;
    questionScore: number;
    authorGender: {
        authorRealName: string;
        female: number;
        male: number;
    };
    contestScore: number;
    taxonomyKeywords: Array<{
        categoryDriver: string[];
        categoryRelevant: string[];
        count: number;
        isFiltered: boolean;
        nerType: string;
        score: number;
        sentIndices: number[];
        sentimentBySent: number[];
        sentimentOverride: boolean[];
        word: string;
    }>;
    translatedTitle: string;
    aggregatedAt: string;
    isQuoteReshare: boolean;
    futureTenseScore: number;
    joyScore: number;
    network: string;
    customerId: string;
    locationId: string;
    tenseCategory: string;
    authorLocation: string;
    isReshare: boolean;
    urgencyScore: number;
    sentimentCategory: string;
    authorKloutScore: number;
    activityTitle: string;
    taxonomyOverallSentiment: number;
    agencyUid: string;
    negativeSentiment: number;
    vulgarityScore: number;
    sadnessScore: number;
    sentimentScoreAnnotated: number;
    authorGenderCategory: string;
    authorId: string;
    authorIdsLiked: string;
    authorIdsReplied: string;
    authorIdsShared: string;
    authorPostsCount: string;
    authorUsernameText: string;
    authorProfileUrl: string;
    bio: string;
    bioAdjectives: string[];
    bioAdverbs: string[];
    bioCategories: string[];
    bioEntities: string[];
    bioNormalizedThemes: string[];
    bioVerbs: string[];
    categories: string[];
    deletedAt: string;
    emojis: string[];
    engagementsAngry: number;
    engagementsCare: number;
    engagementsExits: number;
    engagementsFavorites: number;
    engagementsFire: number;
    engagementsHaha: number;
    engagementsHundred: number;
    engagementsImpressions: number;
    engagementsLastUpdated: string;
    engagementsLinkClicks: number;
    engagementsLove: number;
    engagementsNetworkClicks: number;
    engagementsPride: number;
    engagementsProfileClicks: number;
    engagementsQuoteShares: number;
    engagementsReach: number;
    engagementsReplies: number;
    engagementsSad: number;
    engagementsSaved: number;
    engagementsShares: number;
    engagementsTapsBack: number;
    engagementsTapsForward: number;
    engagementsThankful: number;
    engagementsTotalReactions: number;
    engagementsTwitterEngagements: number;
    engagementsUniqueImpressions: number;
    engagementsVideoViews: number;
    engagementsWow: number;
    entities: string[];
    expandedPostMedia: Array<{
        bytes: number;
        displayUrl: string;
        format: string;
        id: string;
        imageHeight: number;
        imagePages: number;
        imageWidth: number;
        mediaType: string;
        mediaUrl: string;
        metaUrl: string;
        resourceType: string;
        title: string;
        url: string;
        videoBitRate: number;
        videoCodec: string;
        videoCodecLongName: string;
        videoDar: string;
        videoDuration: number;
        videoFrameCount: number;
        videoFrameRate: number;
        videoLevel: number;
        videoPixelFormat: string;
        videoProfile: string;
        videoUrl: string;
    }>;
    hashtags: string[];
    imageNounPhrases: string[];
    imageNouns: string[];
    imageObjectLabels: string[];
    industries: string[];
    industry: string;
    infrastructureRegion: string;
    initialStoredAt: string;
    intents: string[];
    isAd: boolean;
    isPostActivity: boolean;
    keywords: string[];
    logoLabels: string[];
    logoYoloLabels: string[];
    mentions: string[];
    metropolitanStatisticalArea: string;
    normalizedNegativeThemes: string[];
    normalizedPositiveThemes: string[];
    normalizedThemes: string[];
    normalizedUrls: string[];
    notes: string;
    nouns: string[];
    nsfwScore: number;
    parentActivityType: string;
    parentAuthorPictureUrl: string;
    parentAuthorProfileUrl: string;
    parentAuthorRealName: string;
    parentAuthorUsername: string;
    parentId: string;
    parentIsAd: boolean;
    parentPostMedia: string;
    parentRawBodyText: string;
    parentSocialSourceId: string;
    properNouns: string[];
    rawBodyFingerprint: string;
    secondsFromDayStart: number;
    storedAt: string;
    tagIds: string[];
    tags: string[];
    taxonomyCategories: Array<{
        category: string;
        categoryName: string;
        impact: number;
        impactFromSentimentModelScore: number;
        phrase: string;
        phraseWeight: number;
        sentiment: number;
        sentimentOverride: boolean;
        uuid: number;
    }>;
    timeToFirstResponse: number;
    timeToFirstResponseDuringBusinessHours: number;
    timeToResolution: number;
    timeToResolutionDuringBusinessHours: number;
    transcribedRawText: string;
    translatedBodyText: string;
    uniqueHash: string;
    verbs: string[];
    videoObjectLabels: string[];
    webhookReceivedAt: string;
    userAttribution: Array<{
        type: string;
        userId: string;
        visible: boolean;
    }>;
    sanitizedText: string;
    sanitizedTranslatedText: string;
    sanitizedTitle: string;
    sanitizedTranslatedTitle: string;
    surveyTemplateId: string;
    surveyResponseId: string;
    responseState: string;
    r4eParentDocumentId: string;
    repExternalId: string;
    authorUserType: string;
    r4eSourceId: string;
    surveyResponseOrigin: string;
    surveyResponseChannel: string;
    publishStatus: number;
    responseFailedReasonExplanation: string;
    responseFailedReason: string;
}
